import { CardContent, TextField } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardTitle from "@saleor/components/CardTitle";
import FormSpacer from "@saleor/components/FormSpacer";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { useOnlineratesQuery } from "@saleor/currencyrate/queries";
import { CurrencyrateErrorFragment } from "@saleor/fragments/types/CurrencyrateErrorFragment";
import { commonMessages } from "@saleor/intl";
import { ConversionMethodEnum } from "@saleor/types/globalTypes";
import { getFormErrors } from "@saleor/utils/errors";
import getCurrencyrateErrorMessage from "@saleor/utils/errors/currencyrate";
import React from "react";
import { useIntl } from "react-intl";

import { CurrencyratePageFormData } from "../CurrencyratePage/CurrencyratePage";
export interface CurrencyrateDetailsProps {
  data: CurrencyratePageFormData;
  disabled: boolean;
  errors: CurrencyrateErrorFragment[];
  onChange: (event: React.ChangeEvent<any>) => void;
  title: string;
  onlineRate: number;
}
const CurrencyrateDetails: React.FC<CurrencyrateDetailsProps> = ({
  data,
  disabled,
  errors,
  onChange,
  title,
  onlineRate
}) => {
  const intl = useIntl();
  const data1 = useOnlineratesQuery({
    variables: null
  });

  const inputTypeChoices = [
    {
      label: intl.formatMessage({
        defaultMessage: "M1:Floor(amount*rate*2)/2",
        description: "M1:Floor(amount*rate*2)/2"
      }),
      value: ConversionMethodEnum.METHODONE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "M2:Floor(amount*rate*0.2)/0.2)",
        description: "M2:Floor(amount*rate*0.2)/0.2)"
      }),
      value: ConversionMethodEnum.METHODTWO
    },
    {
      label: intl.formatMessage({
        defaultMessage: "M3:Floor(amount*rate*0.02)/0.02)",
        description: "M3:Floor(amount*rate*0.02)/0.02)"
      }),
      value: ConversionMethodEnum.METHODTHREE
    },
    {
      label: intl.formatMessage({
        defaultMessage: "M4:Floor(amount*rate*0.002)/0.002)",
        description: "M4:Floor(amount*rate*0.002)/0.002)"
      }),
      value: ConversionMethodEnum.METHODFOUR
    }
  ];

  if (!!data1.data) {
    for (const index of data1.data.onlinerates) {
      if (data.code === index.toCurrency) {
        onlineRate = index.rate;
        if (title === "add") {
          data.rate = onlineRate;
        }
        break;
      }
    }
  }

  const formErrors = getFormErrors(
    ["code", "name", "symbol", "dipalyformat"],
    errors
  );
  return (
    <Card>
      <CardTitle
        title={intl.formatMessage(commonMessages.generalInformations)}
      />
      <CardContent>
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Name Of Currency",
            description: "the name of the currency converted to"
          })}
          error={!!formErrors.name}
          name={"name" as keyof CurrencyratePageFormData}
          fullWidth
          helperText={getCurrencyrateErrorMessage(formErrors.name, intl)}
          value={data.name}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          error={!!formErrors.code}
          label={intl.formatMessage({
            defaultMessage: "Currency Abbreviations",
            description: "the international abbreviation for currency"
          })}
          name={"code" as keyof CurrencyratePageFormData}
          fullWidth
          helperText={
            getCurrencyrateErrorMessage(formErrors.code, intl) ||
            intl.formatMessage({
              defaultMessage:
                "This is used to match the online exchange rate. Please make sure you type in the international abbreviation",
              description: "currency slug input field helper text"
            })
          }
          value={data.code}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Currency Symbol",
            description: "the identifier for currency"
          })}
          error={!!formErrors.symbol}
          name={"symbol" as keyof CurrencyratePageFormData}
          fullWidth
          helperText={getCurrencyrateErrorMessage(formErrors.symbol, intl)}
          value={data.symbol}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={true}
          label={intl.formatMessage({
            defaultMessage: "Online Rate",
            description: "The online exchange rate for currencies"
          })}
          name={"onlineRate" as keyof CurrencyratePageFormData}
          fullWidth
          value={onlineRate}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Currency Rate",
            description: "Exchange rate of currency"
          })}
          name={"rate" as keyof CurrencyratePageFormData}
          fullWidth
          value={data.rate}
          onChange={onChange}
        />
        <FormSpacer />
        <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Display Order",
            description: "Display Order of currency"
          })}
          name={"displayOrder" as keyof CurrencyratePageFormData}
          fullWidth
          value={data.displayOrder}
          onChange={onChange}
        />
        <FormSpacer />
        {/* <TextField
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Display Format",
            description: "Display Format of currency"
          })}
          name={"displayFormat" as keyof CurrencyratePageFormData}
          fullWidth
          helperText={
            getCurrencyrateErrorMessage(formErrors.dipalyformat, intl) ||
            intl.formatMessage({
              defaultMessage:
                "使用$,USD,0.00组合成前台货币显示样式,三者用空格隔开",
              description: "Display Format of currency"
            })
          }
          value={data.displayFormat}
          onChange={onChange}
        />
        <FormSpacer /> */}
        <SingleSelectField
          choices={inputTypeChoices}
          disabled={disabled}
          label={intl.formatMessage({
            defaultMessage: "Currency conversion method",
            description: "Currency conversion method"
          })}
          name={"conversionMethod" as keyof CurrencyratePageFormData}
          onChange={onChange}
          value={data.conversionMethod}
        />
      </CardContent>
    </Card>
  );
};
export default CurrencyrateDetails;
